import { useEffect } from 'react';

import { useRoleIndexActions } from './RoleIndexContext';

import { getRoles } from './restApi';

const RoleIndexLoader = () => {
  const { initializeState, onResponse, onError } = useRoleIndexActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getRoles({ onResponse, onError });
  }, []);

  return null;
};

export default RoleIndexLoader;
